import Note from "./note";

export default class Err extends Note {
  constructor(code, text, entries, icon) {
    super(text, icon);
    this.code = code;
    this.entries = entries;
  }
}
